<template>
  <p class="color-neutral-subtle mds-text--small-normal">
    <template v-if="refSearch && customerReferences?.includes(refSearch)"
      ><span class="ref-highlight" data-test="reference-search-highlight">{{ refSearch }}</span
      >{{ customerReferences.split(refSearch)[1] }}</template
    >
    <template v-else>{{ customerReferences }}</template>
  </p>
</template>

<script>
import { mapState } from "pinia";
import { shipments } from "@/store/shipments";

export default {
  name: "CustomerReferences",
  props: {
    references: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState(shipments, ["refSearch"]),
    customerReferences() {
      return this.references?.map((reference) => reference?.reference).join(", ");
    }
  }
};
</script>
